import errorParser from '@/utils/error-parser'
import RestResourceService from "@/services/RestResourcesService";

function initialState() {
    return {
        listItems: [],
        blueprintItems: [],
    }
}

export default {
    state: initialState(),
    getters: {
        LIST_ITEMS: state => state.listItems,
        BLUEPRINT_ITEMS: state => state.blueprintItems,
    },
    mutations: {
        SET_LIST_ITEMS(state, payload) {
            state.listItems = payload;
        },
        SET_BLUEPRINT_ITEMS(state, payload) {
            state.blueprintItems = payload;
        },
        RESET(state) {
            const s = initialState();
            Object.keys(s).forEach(key => {
                state[key] = s[key]
            })
        }
    },
    actions: {
        GET_LIST: ({commit, dispatch}, payload) => {
            commit('SET_GLOBAL_LOADING', true);
            return RestResourceService.getResources(payload.url)
                .then((response) => {
                    commit('SET_LIST_ITEMS', response.data.listItems);
                    commit('SET_BLUEPRINT_ITEMS', response.data.blueprintItems);
                    commit('SET_GLOBAL_LOADING', false);
                    return response.data;
                })
                .catch((error) => {
                    commit('SET_GLOBAL_LOADING', false);
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: true,
                        redirectTo500Page: true,
                        clearAuthData: true,
                        redirectToLoginPage: true,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
        POST_LIST: ({commit, dispatch}, payload) => {
            commit('SET_GLOBAL_LOADING', true);
            return RestResourceService.postResources(payload.url, payload.form)
                .then((response) => {
                    commit('SET_GLOBAL_LOADING', false);
                    return response.data;
                })
                .catch((error) => {
                    commit('SET_GLOBAL_LOADING', false);
                    errorParser.parse({
                        error: error,
                        redirectTo404Page: true,
                        redirectTo500Page: true,
                        clearAuthData: true,
                        redirectToLoginPage: true,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
    }
}
